import { buildFormula } from './operation'

export const sparkDemandEstimatedRevenue = buildFormula({
  name: 'Estimated revenue',
  keys: ['sparkDemandEstimatedCpmSum'],
  raw: ({ sparkDemandEstimatedCpmSum }) => sparkDemandEstimatedCpmSum / 1000,
  type: 'monetary',
  isStackable: true,
})

export const sparkDemandEstimatedImpressions = buildFormula({
  name: 'Estimated impressions',
  keys: ['sparkDemandEstimatedImpressionCount'],
  raw: ({ sparkDemandEstimatedImpressionCount }) => sparkDemandEstimatedImpressionCount,
  type: 'shortNumber',
  isStackable: true,
})

export const sparkDemandEstimatedEcpm = buildFormula({
  name: 'Estimated eCPM',
  keys: ['sparkDemandEstimatedCpmSum', 'sparkDemandEstimatedImpressionCount'],
  raw: ({ sparkDemandEstimatedCpmSum, sparkDemandEstimatedImpressionCount }) => (sparkDemandEstimatedImpressionCount ? sparkDemandEstimatedCpmSum / sparkDemandEstimatedImpressionCount : 0),
  type: 'preciseMonetary',
  isStackable: false,
})
